module.exports = __webpack_public_path__ + "static/media/16-web-or-mls-DSC06472.273d1102.jpg";